/**
 * Created by AlexanderC on 3/2/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SourceNotAvailableException = undefined;

var _Exception2 = require('../../Exception/Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let SourceNotAvailableException = exports.SourceNotAvailableException = function (_Exception) {
  _inherits(SourceNotAvailableException, _Exception);

  /**
   * @param {String} type
   * @param {Action|*} action
   */
  function SourceNotAvailableException(type, action) {
    _classCallCheck(this, SourceNotAvailableException);

    return _possibleConstructorReturn(this, (SourceNotAvailableException.__proto__ || Object.getPrototypeOf(SourceNotAvailableException)).call(this, `The ${type} source is not available for the resource '${action.fullName}'`));
  }

  return SourceNotAvailableException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/Exception/SourceNotAvailableException.js
// module id = 424
// module chunks = 0